<template>
  <div/>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';

  export default {
    computed: {
      ...mapGetters({
        hasSeenHome: 'global/hasSeenHome',
        reasonForLoanChange: 'global/reasonForLoanChange',
        sponsorId: 'trackingData/sponsorId'
      })
    },
    mounted () {
      // this is our new guard trigger
      this.setHasSeenHome(true);

      // navigate to the next screen immediately
      this.$di.workflowService.next({ reason: this.reasonForLoanChange });
    },
    methods: {
      ...mapActions({ setHasSeenHome: 'global/setHasSeenHome' })
    }
  };
</script>
